/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Input, Button, Table, Row, message, Col } from "antd";
import { useNavigate } from "react-router";
import { serialNum } from "../../../utils";
import { camelCase, capitaliseWithHyphen } from "../../../utils";
import search_icon from "../../../assests/images/search-icon.svg";
import urls from "../../../api/urls";
import API from "../../../api";
import { APIs, getPremiseId } from "../../../utils/worker";
import { filter } from "fuzzy";
// import { ReactComponent as Scan_check } from "../../../assests/images/SVG/check.svg";
import { ReactComponent as Audit_icon } from "../../../assests/images/middleMile/audited-icon.svg";
import Heading from "../../../components/Heading";
// import { ReactComponent as Scan_check } from "../../../assests/images/SVG/check.svg";

const { GET_ALL_CP_FROM_HUB } = urls;
let premiseId = getPremiseId();

const NewAudit = ({ activeKey }) => {
  const [manifestedCp, SetManifestedCp] = useState();
  const navigate = useNavigate();

  let mock = [
    {
      manifestId: 12323313132,
      status: "OUT-SCANNED",
      premiseId: 489,
      premiseName: "DELHI-GANDHI NAGAR-LAXMI CINEMA",
      createDate: "12-2-110",
      travelBy: "surface",
      awbNumber: 111111111111, //shipemnt
      manifestStatus: "OUTSCANNED",
      service: "standard",
    },
    {
      manifestId: 4584689698648964,
      status: "INSCANNED",
      premiseId: 489,
      premiseName: "DELHI-GANDHI NAGAR-LAXMI CINEMA",
      createDate: "12-2-110",
      travelBy: "surface",
      awbNumber: 22222222222, //child
      manifestStatus: "INSCANNED",
      service: "standard",
    },
    {
      manifestId: 55467546754546,
      status: "OUT-SCANNED",
      premiseId: 489,
      premiseName: "DELHI-GANDHI NAGAR-LAXMI CINEMA",
      createDate: "12-2-110",
      travelBy: "surface",
      awbNumber: 333333333333, //packet
      manifestStatus: "OUTSCANNED",
      service: "standard",
    },
  ];

  const getManifest = async () => {
    setLoading(true);
    let response = await API.Api(
      GET_ALL_CP_FROM_HUB + premiseId?.split("Bearer ")[1]
    ).getWithHeader();
    if (response.status) {
      setLoading(false);

      SetManifestedCp(response.response.data);
    } else {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (activeKey == "2") {
      getManifest();
      console.log("trigared");
    }
  }, [activeKey]);

  const [scannedAwbs, setScannedAwbs] = useState([]);
  const [loading, setLoading] = useState(false);

  function updateStatusByScanValue(codeValue, status) {
    let found = false;
    const updatedMock =
      manifestedCp &&
      manifestedCp
        ?.filter((val) => val.awbNumber == codeValue)
        ?.map((manifest) => {
          found = true;
          if (manifest?.auditStatus) {
            message.error("This Shipment is already auditted");
          } else {
            navigate("/manifest-audit/" + codeValue);
          }
        });
    if (!found) {
      message.error(`No match found for ${codeValue}`);
    }
    // console.log(updatedMock, "updatemock");
  }

  //   console.log(unScannedShipments, "unScannedShipments");

  const columns = [
    {
      title: "Sl No",
      align: "center",
      width: 10,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "Awb No/Packet Id",
      dataIndex: "awbNumber",
      key: "awbNumber",
      render: (text, val) => {
        // console.log(val.status, "text");
        return (
          <div>
            <span style={{ marginRight: "10px" }}>{text}</span>
            {val.auditStatus && <Audit_icon />}
          </div>
        );
      },
    },
    {
      title: "Manifest ID",
      dataIndex: "manifestId",
      key: "manifestId",
    },

    {
      title: "Date",
      dataIndex: "createDate",
      key: "createDate",
      render: (text) => <div style={{ whiteSpace: "nowrap" }}>{text}</div>,
    },
    {
      title: "CP Name",
      dataIndex: "premiseName",
      key: "premiseName",
      render: (text) => <div>{capitaliseWithHyphen(text)}</div>,
    },
    {
      title: "Mode",
      dataIndex: "travelBy",
      key: "travelBy",
      render: (text) => <div>{camelCase(text)}</div>,
    },

    {
      title: "Service Type",
      dataIndex: "service",
      key: "service",
      render: (text) => <div>{camelCase(text)}</div>,
    },
  ];

  return (
    <div className="">
      {/* <Heading title={"Audit Shipment"} /> */}

      <div
        className="consolidated-manifest-cntr m-1"
        // style={{ margin: "40px 20px 20px 40px", padding: "0px 20px 20px 20px" }}
      >
        <div className="header">
          <div className="title"></div>
        </div>
        {/* <Row> */}
        <Table
          columns={columns}
          dataSource={manifestedCp}
          // scroll={{ x: 800 }}
          pagination={false}
          loading={loading}
        />
        {/* </Row> */}
      </div>
    </div>
  );
};

export default NewAudit;

// export default NewAudit;
